import React from "react";
import { I18n } from "@td/shared_utils";

const Link = ({ consultationId }) => (
  <a
    href={Routes.test_video_index_path({
      origin: "consult_request",
      consultation_id: consultationId,
    })}
    rel="opener"
    target="_blank"
  >
    <I18n scope="video_capabilities" text="link" />
  </a>
);

export default Link;
